import React from 'react';
import { connect } from 'react-redux';

import { openBazaarDialog } from 'actions/exchange';
import getVisibleExchangeItems from 'selectors/exchange/getVisibleExchangeItems';

import ExchangeItem from './ExchangeItem';

export function ExchangeItems({ dispatch, items, quantities }) {
  return items.map(item => (
    <ExchangeItem
      key={item.availability.id}
      data={item}
      onClick={() => dispatch(openBazaarDialog(item))}
      quantity={quantities[item.availability.quality.id]}
    />
  ));
}

ExchangeItems.displayName = 'ExchangeItems';

const mapStateToProps = (state, props) => ({
  items: getVisibleExchangeItems(state, props),
});

export default connect(mapStateToProps)(ExchangeItems);